export const localStorageCryptKey: string = 'MR37akeCdi8noaTLkyix6KPtbA1fIYl';
